module.exports = __webpack_public_path__ + "media/images/writer/monitor/sp-balloon-179482257bee2f472b437f5fd77cd14c.png";